import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchGlobalFactory({ globalFactoryParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'GlobalDashboard/GetFactoryDataById',
      params: globalFactoryParams,
    });
    const globalFactory = data;
    yield put(Actions.setGlobalFactory({ globalFactory }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

function* fetchGlobalDashboard({ globalDashboardParams }) {
  try {
    const { data } = yield call(api.get, {
      route: 'GlobalDashboard/GetGlobalDashboard',
    });
    const globalDashboardResult = data;
    yield put(Actions.setGlobalDashboard({ globalDashboardResult }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

function* fetchFactoryConfig({ globalDashboardParams }) {
  try {
    const { data } = yield call(api.get, {
      route: 'GlobalDashboard/GetFactoryConfigurations',
    });
    const factoryConfigResult = data;
    yield put(Actions.setFactoryConfig({ factoryConfigResult }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

function* fetchReleaseVersion() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'GlobalDashboard/GetReleaseVersionData',
    });
    const versionData = data;
    yield put(Actions.setReleaseVersion({ versionData }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_GLOBAL_FACTORY, fetchGlobalFactory),
    takeLatest(ActionTypes.FETCH_GLOBAL_DASHBOARD, fetchGlobalDashboard),
    takeLatest(ActionTypes.FETCH_FACTORY_CONFIG, fetchFactoryConfig),
    takeLatest(ActionTypes.FETCH_RELEASE_VERSION, fetchReleaseVersion),
  ]);
}
